import { render } from "./MockDataBanner.vue?vue&type=template&id=7fb0b568&scoped=true"
import script from "./MockDataBanner.vue?vue&type=script&lang=js"
export * from "./MockDataBanner.vue?vue&type=script&lang=js"

import "./MockDataBanner.vue?vue&type=style&index=0&id=7fb0b568&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb0b568"]])

export default __exports__